module.exports = __webpack_public_path__ + "Dr. Peet-cbca6206.png";